export enum LocalStorageKeys {
    CLOSE_CASHIER_POPUP = "close_cashier_popup",
    FIRST_DEPOSIT_POPUP = "first_deposit_popup",
}
